const MAX_WORD_LENGTH = 45;

function isDialogueTooLong(sentence) {
  const words = sentence.split(' ');
  for (const word of words) {
    if (word.length > MAX_WORD_LENGTH) {
      return true;
    }
  }
  return false;
}

function validateDialogue(caseConf) {
  const warnings = [];
  const errors = [];
  
  const questions = caseConf.dialogue.questions || [];
  for (const question of questions) {
    if (!question.content.en) {
      warnings.push(dialogueWarningOrError('Empty question', question.id));
    } else if (isDialogueTooLong(question.content.en)) {
      errors.push(dialogueWarningOrError(`Question has word that exceeds ${MAX_WORD_LENGTH} characters in length`));
    }
  }
  
  const commands = caseConf.dialogue.commands || [];
  for (const command of commands) {
    if (!command.content.en) {
      warnings.push(dialogueWarningOrError('Empty command', command.id));
    } else if (isDialogueTooLong(command.content.en)) {
      errors.push(dialogueWarningOrError(`Command has word that exceeds ${MAX_WORD_LENGTH} characters in length`));
    }
  }

  const calls = caseConf.dialogue.calls || [];
  for (const call of calls) {
    for (const item of call.items) {
      if (!item.content.en) {
        warnings.push(dialogueWarningOrError('Empty call question', item.id))
      } else if (isDialogueTooLong(item.content.en)) {
        errors.push(dialogueWarningOrError(`Call question has word that exceeds ${MAX_WORD_LENGTH} characters in length`));
      }
    }
  }

  return {
    errors,
    warnings,
  };
}

function dialogueWarningOrError(message, componentId) {
  return {
    message,
    category: 'dialogue',
    field: 'dialogue',
    id: 'dialogue',
    metadata: {
      componentId,
      scope: 'control',
    },
  };
}

export default validateDialogue;
